import React, { useEffect, useMemo, useState } from "react";
import { AgGridReact } from '@ag-grid-community/react';

import "./LiveDashboard.css";
import { TransitTimeTrendChart } from "./TransitTimeTrendChart";
import { DashboardHeaderBanner } from "./DashboardHeaderSlot.jsx";
import redirectURL from '../../redirectURL';
import {
  DEFAULT_PERFORMANCE_CONFIG,
  fetchPerformanceConfig,
  performanceLabel,
  performanceFill,
  performanceFillForLabel,
  PerformanceLegend,
} from "./performanceConfig";
import "@ag-grid-community/core/dist/styles/ag-grid.css";
import "@ag-grid-community/core/dist/styles/ag-theme-balham.css"; // ✅ use this (community)
import Select from 'react-select';



function SelectSimple(props) {
  return (
    <select className="select" value={props.value} onChange={props.onChange}>
      {props.children}
    </select>
  );
}

export default function LiveDashboard({ globalFilters, activeSubTab = "all" }) {
  
  const [data, setData] = useState([]);
  const [processedData, setProcessedData] = useState([]);
  const [filteredProcessedData, setFilteredProcessedData] = useState([]);
  const [gurgaonProcessedData, setGurgaonProcessedData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Performance bands from Masters > Hub Performance Config, re-read on every mount
  // so a change there shows on the next dashboard load.
  const [perfConfig, setPerfConfig] = useState(DEFAULT_PERFORMANCE_CONFIG);
  useEffect(function () {
    var cancelled = false;
    fetchPerformanceConfig().then(function (config) {
      if (!cancelled) setPerfConfig(config);
    });
    return function () { cancelled = true; };
  }, []);

  const [showHubOverview, setShowHubOverview] = useState(true);
  const [showGurgaonHubOverview, setShowGurgaonHubOverview] = useState(true);

  const [chartView, setChartView] = useState("gr"); // "gr" | "transit"
  const [gurgaonChartView, setGurgaonChartView] = useState("gr");

  const [lastRefreshTime, setLastRefreshTime] = useState(null);
  const [trendWarehouse, setTrendWarehouse] = useState("all");
  const [trendHub, setTrendHub] = useState("all");
  var [timeRangeAll, setTimeRangeAll] = useState("weekly");

  const [countersData, setCountersData] = useState({
    totalHubs:0,totalGRs:0,deliveredGRs:0,intransitGRs:0,invalidGRs:0,unmappedHubGRs:0,within48Hrs:0, gt48Hrs:0,avgTransitTime:0, savings:0, gt48HrsPct:0, within48HrsPct:0
  });
  const [hubSummary, setHubSummary] = useState([]);
  const [perfComparison, setPerfComparison] = useState([]);
  const [gurgaonCountersData, setGurgaonCountersData] = useState({
    gurgaonHubs:0,totalGRs:0,deliveredGRs:0,intransitGRs:0,invalidGRs:0,unmappedHubGRs:0,within120Hrs:0, gt120Hrs:0,avgTransitTime:0,savings:0,within120HrsPct:0, gt120HrsPct:0
  });
  const [gurgaonHubSummary, setGurgaonHubSummary] = useState([]);
  const [gurgaonPerfComparison, setGurgaonPerfComparison] = useState([]);

  
  var [gurgoanTrendHub, setGurgoanTrendHub] = useState("all");
  var [gurgaonWarehouse, setGurgaonWarehouse] = useState("all");
  var [timeRangeGurgaon, setTimeRangeGurgaon] = useState("weekly");
  var [trendLoading, setTrendLoading] = useState(false);
  var warehouseNameMap = {
  MSILG: "GURGAON",
  MSILK: "KHARKHODA"
};

    // ===== Data states =====
  var [trendApiAll, setTrendApiAll] = useState([]);        // array of trend points (all)
  var [trendApiGurgaon, setTrendApiGurgaon] = useState([]);
var [fromDate, setFromDate] = useState(function () {
  var today = new Date();
  var d = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  var targetMonth = d.getMonth() - 1;
  d.setMonth(targetMonth);

  if (d.getMonth() !== ((targetMonth % 12) + 12) % 12) {
    d = new Date(today.getFullYear(), today.getMonth(), 0);
  }

  return formatInputDate(d);
});

var [toDate, setToDate] = useState(function () {
  return formatInputDate(new Date());
});

  

  // -------------------------------
  // Fetch CSV
  // -------------------------------
  useEffect(function () {
    fetchData();
    // fetchCSVData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSubTab]);
useEffect(
  function () {
    setTrendLoading(true);

    if (activeSubTab === "all") {
      setTimeRangeAll("weekly");
      setTrendHub("all");
      setTrendWarehouse("all");
      setTrendApiAll([]);
    } else {
      setTimeRangeGurgaon("weekly");
      setGurgoanTrendHub("all");
      setGurgaonWarehouse("all");
      setTrendApiGurgaon([]);
    }
  },
  [activeSubTab]
);
useEffect(
  function () {
    var cancelled = false;

    async function run() {
      try {
        var isAllTab = activeSubTab === "all";

        var type = isAllTab ? "all" : "gurgaon";
        var timeRange = isAllTab ? timeRangeAll : timeRangeGurgaon;
        var hub = isAllTab ? trendHub : gurgoanTrendHub;
        var warehouse = isAllTab ? trendWarehouse : gurgaonWarehouse;

        if (isAllTab) setTrendApiAll([]);
        else setTrendApiGurgaon([]);

        var data = await fetchTrendData(type, timeRange, hub, warehouse);

        if (!cancelled) {
          if (isAllTab) setTrendApiAll(data);
          else setTrendApiGurgaon(data);
        }
      } catch (e) {
        console.error("Trend API error", e);
        if (!cancelled) {
          if (activeSubTab === "all") setTrendApiAll([]);
          else setTrendApiGurgaon([]);
        }
      }
    }

    run();

    return function () {
      cancelled = true;
    };
  },
  [
    activeSubTab,
    timeRangeAll,
    trendHub,
    trendWarehouse,
    timeRangeGurgaon,
    gurgoanTrendHub,
    gurgaonWarehouse,
    fromDate,
    toDate
  ]
);

  async function fetchData() {
  setLoading(true);

  try {
    const params = {
        from_date: fromDate,
        to_date: toDate,
      }

    const url =
      activeSubTab === "all"
        ? "/msildashboard/fetchLiveDashboardAllHub"
        : "/msildashboard/fetchLiveDashboardGurgaonHub";

    const response = await redirectURL.post(url, params);

    // ✅ Node wrapper: success is response.data.status === "Success"
    const responseData =
      response && response.data && response.data.status === "Success"
        ? response.data
        : null;

    if (!responseData) {
      console.warn(
        "API failed:",
        response && response.data ? response.data : response
      );
      return; // stop here, finally will run
    }

    // ✅ normalized keys from node
    const countersResp = responseData.live_layer_1_ui_data || {};
    const hubSummaryResp = Array.isArray(responseData.live_layer_2_ui_data)
      ? responseData.live_layer_2_ui_data
      : [];
    const perfCompResp = Array.isArray(responseData.live_layer_3_ui_data)
      ? responseData.live_layer_3_ui_data
      : [];

    if (activeSubTab === "all") {
      setCountersData({
        totalHubs: countersResp.total_hubs || 0,
        totalGRs: countersResp.total_grs || 0,
        deliveredGRs: countersResp.delivered_gr_count || 0,
        intransitGRs: countersResp.intransit_grs || 0,
        invalidGRs: countersResp.invalid_grs || 0,
        unmappedHubGRs: countersResp.unmapped_hub_grs_count || 0,
        within48Hrs: countersResp.delivered_gr_within_48h || 0,
        gt48Hrs: countersResp.delivered_gr_above_48h || 0,
        avgTransitTime: countersResp.avg_transit_time || 0,
        within48HrsPct: countersResp.delivered_within_48h_percentage || 0,
        gt48HrsPct: countersResp.delivered_above_48h_percentage || 0,
        savings: convertToMillion(countersResp.savings)
      });

      setHubSummary(hubSummaryResp);
      setPerfComparison(perfCompResp);
      setLastRefreshTime(new Date());
    } else {
      // activeSubTab === "gurgaon"
      setGurgaonCountersData({
        gurgaonHubs: countersResp.total_hubs || 0,
        totalGRs: countersResp.total_grs || 0,
        deliveredGRs: countersResp.delivered_gr_count || 0,
        intransitGRs: countersResp.intransit_grs || 0,
        invalidGRs: countersResp.invalid_grs || 0,
        unmappedHubGRs: countersResp.unmapped_hub_grs_count || 0,
        within120Hrs: countersResp.delivered_gr_within_120h || 0,
        gt120Hrs: countersResp.delivered_gr_above_120h || 0,
        avgTransitTime: countersResp.avg_transit_time || 0,
        within120HrsPct:countersResp.delivered_within_120h_percentage || 0,
        gt120HrsPct: countersResp.delivered_above_120h_percentage || 0,
        savings: convertToMillion(countersResp.savings)
      });

      setGurgaonHubSummary(hubSummaryResp);
      setGurgaonPerfComparison(perfCompResp);
      setLastRefreshTime(new Date());
    }
  } catch (err) {
    console.error("Error in fetchData:", err);
  } finally {
    setLoading(false);
  }
}

async function fetchTrendData(type, timeRange, hub, warehouse) {
  const url =
    type === "all"
      ? "/msildashboard/fetchLiveTransitTimeTrendAll"
      : "/msildashboard/fetchLiveTransitTimeTrendGurgaon";

  const params = { by: timeRange, hub: hub, warehouse: warehouse, from_date: fromDate, to_date: toDate };
setTrendLoading(true);

  try {
    const response = await redirectURL.post(url, params);

    if (response && response.data && response.data.status === "Success") {
      
      return Array.isArray(response.data.trend_data) ? response.data.trend_data : [];
    }

    console.warn("Trend API failed:", response && response.data ? response.data : response);
    return [];
  } catch (err) {
    console.error("fetchTrendData error:", err);
    return [];
  }finally{
    setTrendLoading(false);
  }
}



  function fetchCSVData (){
    fetch(
      "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Daily%20Tracking%20Report-XWNUZrPBZAkdF2bU1HnJhA5ixdgMD6.csv"
    )
      .then(function (res) {
        return res.text();
      })
      .then(function (csvText) {
        console.log(csvText, "csvText");
        
        var parsed = parseCSV(csvText);

        console.log(parsed, "parsedCSV");
        
        setData(parsed);

        var processed = processRawData(parsed);

        console.log(processed, "processed");
        
        setProcessedData(processed);

        setLastRefreshTime(new Date());
      })
      .catch(function (err) {
        console.error("Error fetching CSV:", err);

        var dummy = generateDummyData();
        setData(dummy);

        var processed = processRawData(dummy);
        setProcessedData(processed);

        setLastRefreshTime(new Date());
      })
      .finally(function () {
        setLoading(false);
      });
  }
  

  function parseCSV(csvText) {
    var lines = csvText.split("\n");
    if (!lines.length) return [];

    var headers = lines[0]
      .split(",")
      .map(function (h) {
        return String(h).trim().replace(/"/g, "");
      });

    return lines
      .slice(1)
      .map(function (line) {
        var values = line.split(",").map(function (v) {
          return String(v).trim().replace(/"/g, "");
        });
        var row = {};
        headers.forEach(function (header, index) {
          row[header] = values[index] || "";
        });
        return row;
      })
      .filter(function (row) {
        return row["Consignment Code"];
      });
  }

  function processRawData(rawData) {
    return rawData.map(function (row, index) {
      var gateOut = parseDateTime(row["Gate out Time"]);
      var delivery = parseDateTime(row["Delivery time at Consignee*"]);

      var deliveryDurationHr = parseFloat(row["Overall transit time(Hrs.Min)"]) || 0;
      if (deliveryDurationHr === 0 && gateOut && delivery) {
        deliveryDurationHr = (delivery.getTime() - gateOut.getTime()) / (1000 * 60 * 60);
      }
      if (deliveryDurationHr === 0) deliveryDurationHr = 20 + Math.random() * 30;

      var firstMileHr = parseFloat(row["Transit time-1st Mile(Hrs.Min)"]) || 0;
      if (firstMileHr === 0) firstMileHr = 3.5 + Math.random() * 2;

      var lastMileHr = parseFloat(row["Transit time-Last Mile(Hrs.Min)"]) || 0;
      if (lastMileHr === 0) lastMileHr = 2.0 + Math.random() * 2;

      var status = row["Status"] || "Unknown";
      var isDelivered = String(status).toLowerCase() === "delivered";
      var isWithin48Hr = deliveryDurationHr > 0 && deliveryDurationHr <= 48;

      return {
        grNo: row["Consignment Code"] || "GR" + (index + 1),
        consignment: row["Consignment Code"] || "GR" + (index + 1),
        wrhs: row["Consigner Code"] || "UNKNOWN",
        hub: row["Consigner Code"] || "UNKNOWN",
        city: row["City"] || row["Consignee Code"] || "UNKNOWN",
        gateOutDateTime: gateOut,
        deliveryDateTime: delivery,
        deliveryDurationHr: deliveryDurationHr,
        firstMileHr: firstMileHr,
        lastMileHr: lastMileHr,
        status: status,
        isDelivered: isDelivered,
        isWithin48Hr: isDelivered && isWithin48Hr,
      };
    });
  }

  function parseDateTime(dateStr) {
    if (!dateStr || String(dateStr).trim() === "") return null;
    try {
      var parts = String(dateStr).split(" ");
      if (parts.length !== 2) return null;

      var datePart = parts[0];
      var timePart = parts[1];

      var dmy = datePart.split("-");
      if (dmy.length !== 3) return null;

      var day = dmy[0];
      var month = dmy[1];
      var year = dmy[2];

      var hm = timePart.split(":");
      if (hm.length !== 2) return null;

      var hour = hm[0];
      var minute = hm[1];

      var monthMap = {
        Jan: 0,
        Feb: 1,
        Mar: 2,
        Apr: 3,
        May: 4,
        Jun: 5,
        Jul: 6,
        Aug: 7,
        Sep: 8,
        Oct: 9,
        Nov: 10,
        Dec: 11,
      };

      return new Date(
        parseInt(year, 10),
        monthMap[month],
        parseInt(day, 10),
        parseInt(hour, 10),
        parseInt(minute, 10)
      );
    } catch (e) {
      return null;
    }
  }

  function generateDummyData() {
    var hubs = ["RPDC-GUJ", "RPDC-DEL", "RPDC-MUM", "RPDC-CHE", "RPDC-KOL"];
    var cities = ["MUMBAI", "DELHI", "BANGALORE", "CHENNAI", "KOLKATA", "PUNE", "HYDERABAD"];
    var statuses = ["Delivered", "In Transit", "Pending"];

    return Array.from({ length: 100 }, function (_, i) {
      var baseDate = new Date(2025, 0, 1);
      var randomDays = Math.floor(Math.random() * 30);
      var gateOutDate = new Date(baseDate.getTime() + randomDays * 24 * 60 * 60 * 1000);
      var deliveryDate = new Date(gateOutDate.getTime() + (20 + Math.random() * 30) * 60 * 60 * 1000);

      function formatDate(d) {
        // "01-Jan-2025 03:39" like
        var dd = String(d.getDate()).padStart(2, "0");
        var months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
        var mon = months[d.getMonth()];
        var yyyy = d.getFullYear();
        var hh = String(d.getHours()).padStart(2, "0");
        var mm = String(d.getMinutes()).padStart(2, "0");
        return dd + "-" + mon + "-" + yyyy + " " + hh + ":" + mm;
      }

      return {
        "Serial Number": String(i + 1),
        "Truck No": "HR38AC" + (6000 + i),
        "Transporter Code": "MARLHAS",
        Status: statuses[i % statuses.length],
        "MGPA Date Time": "31-Dec-2024 21:17",
        "Consignment Code": "HAR" + (1005000 + i),
        "Consignee Code": "DDL" + String(i).padStart(4, "0"),
        "Consignee Name": "Customer " + (i + 1),
        "Consigner Code": hubs[i % hubs.length],
        "Eway Bill No": String(691835000000 + i),
        "Consignee Clubbing": "5",
        City: cities[i % cities.length],
        "Total CMT": "15.82",
        "Gate out Time": formatDate(gateOutDate),
        "Reporting Time at Hub (GPS)": "01-Jan-2025 20:50",
        "Actual Arrival at Hub (Manual)*": "01-Jan-2025 20:55",
        "POD First Mile*": "Ok",
        "First Mile Comment": "PRIMARY VEHICLE",
        "POD First Mile Download": "",
        "Dispatch time from Hub*": "02-Jan-2025 09:20",
        "Last Mile Fleet Availability*": "Fleet Master",
        "Last Mile Vehicle Type*": "TATA 709",
        "Last Mile Vehicle No*": "MH04LY" + (3000 + i),
        "POD-Last Mile*": "Ok",
        "Last Mile Comment": "DELIVERED",
        "POD Last Mile Download": "[object Object]",
        "Reporting time at consignee*": "02-Jan-2025 12:30",
        "Delivery time at Consignee*": formatDate(deliveryDate),
        "Transit time-1st Mile(Hrs.Min)": (15 + Math.random() * 10).toFixed(1),
        "Transit time-Last Mile(Hrs.Min)": (2 + Math.random() * 4).toFixed(1),
        "Overall transit time(Hrs.Min)": (30 + Math.random() * 20).toFixed(1),
        Remark: "DELIVERY COMPLETED",
        "Show last Mile Trucks": "",
      };
    });
  }

  function formatRefreshTime(date) {
    if (!date) return "Never";
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  }

  function getFilteredData() {
    var filtered = data;

    if (
      globalFilters &&
      globalFilters.selectedWarehouse &&
      globalFilters.selectedWarehouse !== "" &&
      globalFilters.selectedWarehouse !== "all"
    ) {
      filtered = filtered.filter(function (row) {
        return row["Consigner Code"] === globalFilters.selectedWarehouse;
      });
    }

    if (globalFilters && globalFilters.fromDate) {
      // fromDate filtering placeholder
    }
    if (globalFilters && globalFilters.toDate) {
      // toDate filtering placeholder
    }

    return filtered;
  }
  

   var trendData = useMemo(function () {
    var out = trendApiAll.slice(0);

    return out;
  }, [trendApiAll]);

  var gurgoanTrendData = useMemo(function () {    
    var out = trendApiGurgaon.slice(0);

    return out;
  }, [trendApiGurgaon]);
  // -------------------------------
  // UI Helpers
  // -------------------------------
  function IconBox(props) {
    return (
      <div className={"kpiIcon " + (props.bg || "")}>
        <span className={"kpiEmoji " + (props.color || "")}>{props.children}</span>
      </div>
    );
  }

  function ButtonSimple(props) {
    var cls = "btn " + (props.variant === "primary" ? "btnPrimary" : "btnOutline");
    return (
      <button className={cls} type="button" onClick={props.onClick}>
        {props.children}
      </button>
    );
  }


  // -------------------------------
  // Loading
  // -------------------------------
  // if (loading) {
  //   return (
  //     <div className="centerScreen">
  //       <div className="loadingText">Loading dashboard...</div>
  //     </div>
  //   );
  // }
  function MiniCardsFromTrend(props) {
  var data = props.data || [];
  var labelShown = props.labelShown || "Total Hubs";

  // top series count shown on chart = unique hubs up to 5
  var summary = useMemo(function () {
    return computeSummaryFromTrend(data, 5, activeSubTab);
  }, [data]);

  return (
    <div className="miniCards">
      <div className="miniCard">
        <div className="miniCardLabel">{labelShown}</div>
        <div className="miniCardValue">{summary.shownCount}</div>
      </div>

      <div className="miniCard">
        <div className="miniCardLabel">Best Performance</div>
        <div className="miniCardValue" style={{color: "#2e7d32"}}>
          {summary.bestHub ? summary.bestHub + " - " + summary.bestAvg.toFixed(2) + "h" : "N/A"}
        </div>
      </div>

      <div className="miniCard">
        <div className="miniCardLabel">Poor Performance</div>
        <div className="miniCardValue"  style={{color: "#d32f2f"}}>
          {summary.poorHub ? summary.poorHub + " - " + summary.poorAvg.toFixed(2) + "h" : "N/A"}
        </div>
      </div>
    </div>
  );
}
function getAllHubColumnDefs(perfConfig) {
  var setFilterParams = {
    buttons: ["reset", "apply"],
    closeOnApply: true,
    suppressMiniFilter: false,
    refreshValuesOnOpen: true, // values only from current grid data
  };

  function n(v) {
    var x = typeof v === "number" ? v : parseFloat(v || 0);
    return isNaN(x) ? 0 : x;
  }

  function bigNumberCell(colorClass) {
  return function (params) {
    var rawValue = params && params.value;

    var val = rawValue != null && !isNaN(rawValue)
      ? n(rawValue)
      : 0;

    return (
      '<div class="tc">' +
        '<div class="bigNumber ' + colorClass + '">' + val + "</div>" +
      "</div>"
    );
  };
}
  

  function pctBucket(pct) {
  var p = typeof pct === "number" ? pct : parseFloat(pct || 0);
  if (isNaN(p)) p = 0;

  // clamp 0..100
  if (p < 0) p = 0;
  if (p > 100) p = 100;

  var start = Math.floor(p / 10) * 10;
  var end = start + 10;

  if (start === 100) return "100%";
  return start + "% - " + end + "%";
}

var pctSetFilterParams = {
  buttons: ["reset", "apply"],
  closeOnApply: true,
  suppressMiniFilter: false,  // ✅ search box
  refreshValuesOnOpen: true,  // ✅ values only from current grid data

  // ✅ keep buckets in correct order
  comparator: function (a, b) {
    function startNum(x) {
      if (!x) return 0;
      if (x === "100%") return 100;
      var n = parseInt(String(x).split("%")[0], 10);
      return isNaN(n) ? 0 : n;
    }
    return startNum(a) - startNum(b);
  }
};


  return [
    // ✅ Warehouse
    {
      headerName: "Warehouse",
      field: "warehouse",
      filter: "agSetColumnFilter",
      filterParams: setFilterParams,
      width: 120,
      cellRenderer: function (params) {
        var value = params && params.value ? params.value : "";
        return (
          '<div class="badgeBox blueSoft">' +
            '<span class="badgeText blueText">' + value + "</span>" +
          "</div>"
        );
      },
    },

    // ✅ Hub
    {
      headerName: "Hub",
      field: "hub_location",
      filter: "agSetColumnFilter",
      filterParams: setFilterParams,
      width: 120,
      cellRenderer: function (params) {
        var value = params && params.value ? params.value : "";
        return '<div class="hubText">' + value + "</div>";
      },
    },

    // Hub operator (current operator from hub_operator_master)
    {
      headerName: "Hub Operator",
      field: "hub_operator_code",
      filter: "agSetColumnFilter",
      filterParams: setFilterParams,
      width: 150,
      cellRenderer: function (params) {
        var value = params && params.value ? params.value : "";
        return '<div class="hubText">' + value + "</div>";
      },
    },

    // ✅ Performance (Excellent/Good/Poor)
    {
      headerName: "Performance",
      colId: "performance_bucket",
      filter: "agSetColumnFilter",
      filterParams: setFilterParams,
      width: 130,
      valueGetter: function (params) {
        var row = params && params.data ? params.data : {};
        var total = n(row.total_grs);
        var within = n(row.within_48h);
        var pct = total ? (within / total) * 100 : 0;

        return performanceLabel(pct, perfConfig);
      },
      cellRenderer: function (params) {
        var v = params && params.value ? params.value : "";
        var perfDot = performanceFillForLabel(v);

        return (
          '<span class="inlineCenter">' +
            '<span class="dot ' + perfDot + '"></span>' +
            '<span class="bold">' + v + "</span>" +
          "</span>"
        );
      },
    },

  {
  headerName: "Within 48 Hours Delivery",
  colId: "within_48_bucket",
  minWidth: 230,

  // checkbox list filter
  filter: "agSetColumnFilter",
  filterParams: pctSetFilterParams,

  // drives set-filter bucket values
  valueGetter: function (params) {
    var row = (params && params.data) ? params.data : {};

    var total = Number(row.total_grs);
    if (!isFinite(total)) total = 0;

    var within = Number(row.within_48h);
    if (!isFinite(within)) within = 0;

    var pct = total > 0 ? (within / total) * 100 : 0;
    if (!isFinite(pct)) pct = 0;

    return pctBucket(pct);
  },

  // UI (% + bar) + tooltip on hover ("within of total")
  cellRenderer: function (params) {
    var row = (params && params.data) ? params.data : {};

    var total = Number(row.total_grs);
    if (!isFinite(total)) total = 0;

    var within = Number(row.within_48h);
    if (!isFinite(within)) within = 0;

    var pct = total > 0 ? (within / total) * 100 : 0;
    if (!isFinite(pct)) pct = 0;

    var perfDot = performanceFill(pct, perfConfig);

    // title tooltip text (shows on hover)
    var tip = within + " of " + total;

    // IMPORTANT: escape quotes to avoid breaking HTML
    tip = String(tip).replace(/"/g, "&quot;");

    return (
      '<div class="miniBlock" title="' + tip + '">' +
        '<div class="bold">' + pct.toFixed(1) + '%</div>' +
        '<div class="miniBar">' +
          '<div class="miniBarFill ' + perfDot + '" style="width:' + Math.min(pct, 100) + '%"></div>' +
        "</div>" +
      "</div>"
    );
  }
}

,


   {
  headerName: ">48 hours Delivery",
  colId: "above_48_bucket",
  minWidth: 210,

  filter: "agSetColumnFilter",
  filterParams: pctSetFilterParams,

  // Drives bucket filter
  valueGetter: function (params) {
    var row = (params && params.data) ? params.data : {};

    var total = Number(row.total_grs);
    if (!isFinite(total)) total = 0;

    var within = Number(row.within_48h);
    if (!isFinite(within)) within = 0;

    var over = total > 0 ? (total - within) : 0;
    var pct = total > 0 ? (over / total) * 100 : 0;

    if (!isFinite(pct)) pct = 0;

    return pctBucket(pct);
  },

  // UI + title tooltip
  cellRenderer: function (params) {
    var row = (params && params.data) ? params.data : {};

    var total = Number(row.total_grs);
    if (!isFinite(total)) total = 0;

    var within = Number(row.within_48h);
    if (!isFinite(within)) within = 0;

    var over = total > 0 ? (total - within) : 0;
    var pct = total > 0 ? (over / total) * 100 : 0;

    if (!isFinite(pct)) pct = 0;

    var tip = over + " of " + total;
    tip = String(tip).replace(/"/g, "&quot;");

    return (
      '<div class="miniBlock" title="' + tip + '">' +
        '<div class="bold">' + pct.toFixed(1) + '%</div>' +
        '<div class="miniBar">' +
          '<div class="miniBarFill redFill" style="width:' + Math.min(pct, 100) + '%"></div>' +
        "</div>" +
      "</div>"
    );
  }
}

,

    // ✅ Avg Transit Time (purple like old table)
    {
      headerName: "Avg. Transit Time",
      field: "avg_transit_time",
      width: 130,
      filter: "agSetColumnFilter",
      filterParams: setFilterParams,
      cellRenderer: function (params) {
        var val = n(params && params.value);
        return (
          '<div class="tc">' +
          '<div class="bigNumber purpleText">' + val.toFixed(1) + "h</div>" +
          "</div>"
        );
      },
    },

    // ✅ Total GRs (blue big number + muted)
    {
      headerName: "Total GRs nos.",
      field: "total_grs",
      filter: "agSetColumnFilter",
      filterParams: setFilterParams,
      width: 100,
      cellRenderer: bigNumberCell("blueText", "", "total"),
    },

    // ✅ Delivered GRs (green big number + muted)
    {
      headerName: "Delivered GRs nos.",
      field: "delivered_grs",
      filter: "agSetColumnFilter",
      filterParams: setFilterParams,
      width: 100,
      cellRenderer: bigNumberCell("greenText", "", "deliveries"),
    },

    // ✅ Within 24 Hours (blue big number + muted)
    {
      headerName: "GR within 24 Hours (nos.)",
      field: "delivered_within_24h",
      filter: "agSetColumnFilter",
      filterParams: setFilterParams,
      width: 120,
      cellRenderer: bigNumberCell("blueText", "", "count"),
    },

    // ✅ In Transit (orange big number + muted)
    {
      headerName: "In Transit GR(nos.)",
      field: "in_transit_count",
      filter: "agSetColumnFilter",
      filterParams: setFilterParams,
      width: 100,
      cellRenderer: bigNumberCell("orangeText", "", "in transit"),
    },
    {
      headerName: "Invalid Transit Time GRs",
      field: "invalid_grs",
      filter: "agSetColumnFilter",
      filterParams: setFilterParams,
      width: 150,
      cellRenderer: bigNumberCell("redText", "", "transit"),
    },

    // ✅ Truck Cost (blue big number + muted ₹ cost)
    // {
    //   headerName: "Truck Cost(₹)",
    //   field: "truck_cost",
    //   filter: "agSetColumnFilter",
    //   filterParams: setFilterParams,
    //   width: 100,
    //   cellRenderer: moneyCell("blueText"),
    // },

    // ✅ Courier Cost (blue big number + muted ₹ cost)
    // {
    //   headerName: "Courier Cost(₹)",
    //   field: "courier_cost",
    //   filter: "agSetColumnFilter",
    //   filterParams: setFilterParams,
    //   width: 100,
    //   cellRenderer: moneyCell("blueText"),
    // },

    // ✅ Savings (green big number + muted ₹ saving)
    // {
    //   headerName: "Savings(₹)",
    //   field: "savings",
    //   filter: "agSetColumnFilter",
    //   filterParams: setFilterParams,
    //   width: 100,
    //   cellRenderer: savingsCell(),
    // },
  ];
}
function getGurgaonHubColumnDefs(perfConfig) {
  var setFilterParams = {
    buttons: ["reset", "apply"],
    closeOnApply: true,
    suppressMiniFilter: false,
    refreshValuesOnOpen: true,
  };

  function n(v) {
    var x = typeof v === "number" ? v : parseFloat(v || 0);
    return isNaN(x) ? 0 : x;
  }

 function bigNumberCell(colorClass) {
  return function (params) {
    var rawValue = params && params.value;

    var val = rawValue != null && !isNaN(rawValue)
      ? n(rawValue)
      : 0;

    return (
      '<div class="tc">' +
        '<div class="bigNumber ' + colorClass + '">' + val + "</div>" +
      "</div>"
    );
  };
}


 


  function pctBucket(pct) {
    var p = typeof pct === "number" ? pct : parseFloat(pct || 0);
    if (isNaN(p)) p = 0;
    if (p < 0) p = 0;
    if (p > 100) p = 100;

    var start = Math.floor(p / 10) * 10;
    var end = start + 10;

    if (start === 100) return "100%";
    return start + "% - " + end + "%";
  }

  var pctSetFilterParams = {
    buttons: ["reset", "apply"],
    closeOnApply: true,
    suppressMiniFilter: false,
    refreshValuesOnOpen: true,
    comparator: function (a, b) {
      function startNum(x) {
        if (!x) return 0;
        if (x === "100%") return 100;
        var nn = parseInt(String(x).split("%")[0], 10);
        return isNaN(nn) ? 0 : nn;
      }
      return startNum(a) - startNum(b);
    },
  };

  return [
    // Warehouse
    {
      headerName: "Warehouse",
      field: "warehouse",
      filter: "agSetColumnFilter",
      filterParams: setFilterParams,
      width: 120,
      cellRenderer: function (params) {
        var value = params && params.value ? params.value : "";
        return (
          '<div class="badgeBox orangeSoft">' +
            '<span class="badgeText orangeText">' + value + "</span>" +
          "</div>"
        );
      },
    },
    {
      headerName: "Warehouse Name",
      field: "warehouse_name",
      valueGetter: function (params){
        var warehouse = params && params.data && params.data.warehouse ? params.data.warehouse : "";
        return warehouseNameMap[warehouse] || ""
      },
      filter: "agSetColumnFilter",
      filterParams: setFilterParams,
      width: 140,
       cellRenderer: function (params) {
        var value = params && params.value ? params.value : "";
        return '<div class="hubText">' + value + "</div>";
      },
    },

    // Hub
    {
      headerName: "Hub",
      field: "hub_location",
      filter: "agSetColumnFilter",
      filterParams: setFilterParams,
      width: 140,
      cellRenderer: function (params) {
        var value = params && params.value ? params.value : "";
        return '<div class="hubText">' + value + "</div>";
      },
    },

    // Hub operator (current operator from hub_operator_master)
    {
      headerName: "Hub Operator",
      field: "hub_operator_code",
      filter: "agSetColumnFilter",
      filterParams: setFilterParams,
      width: 150,
      cellRenderer: function (params) {
        var value = params && params.value ? params.value : "";
        return '<div class="hubText">' + value + "</div>";
      },
    },

    // Performance bucket based on % within 120
    {
      headerName: "Performance",
      colId: "performance_bucket_gurgaon",
      filter: "agSetColumnFilter",
      filterParams: setFilterParams,
      width: 130,
      valueGetter: function (params) {
        var row = params && params.data ? params.data : {};
        var total = n(row.total_grs);
        var within = n(row.within_120h);
        var pct = total ? (within / total) * 100 : 0;

        return performanceLabel(pct, perfConfig);
      },
      cellRenderer: function (params) {
        var v = params && params.value ? params.value : "";
        var perfDot = performanceFillForLabel(v);

        return (
          '<span class="inlineCenter">' +
            '<span class="dot ' + perfDot + '"></span>' +
            '<span class="bold">' + v + "</span>" +
          "</span>"
        );
      },
    },

    // Within 120 Hours Delivery (mini bar) + set filter buckets
    {
  headerName: "Within 120 Hours Delivery",
  colId: "within_120_bucket",
  minWidth: 240,
  filter: "agSetColumnFilter",
  filterParams: pctSetFilterParams,

  valueGetter: function (params) {
    var row = (params && params.data) ? params.data : {};

    var total = Number(row.total_grs);
    if (!isFinite(total)) total = 0;

    var within = Number(row.within_120h);
    if (!isFinite(within)) within = 0;

    var pct = total > 0 ? (within / total) * 100 : 0;
    if (!isFinite(pct)) pct = 0;

    return pctBucket(pct);
  },

  cellRenderer: function (params) {
    var row = (params && params.data) ? params.data : {};

    var total = Number(row.total_grs);
    if (!isFinite(total)) total = 0;

    var within = Number(row.within_120h);
    if (!isFinite(within)) within = 0;

    var pct = total > 0 ? (within / total) * 100 : 0;
    if (!isFinite(pct)) pct = 0;

    var perfDot = performanceFill(pct, perfConfig);

    // Tooltip text
    var tip = within + " of " + total;
    tip = String(tip).replace(/"/g, "&quot;");

    return (
      '<div class="miniBlock" title="' + tip + '">' +
        '<div class="bold">' + pct.toFixed(1) + '%</div>' +
        '<div class="miniBar">' +
          '<div class="miniBarFill ' + perfDot + '" style="width:' + Math.min(pct, 100) + '%"></div>' +
        "</div>" +
      "</div>"
    );
  }
},


    // >120 Hours Delivery (mini bar) + set filter buckets
 {
  headerName: ">120 hours Delivery",
  colId: "above_120_bucket",
  minWidth: 220,
  filter: "agSetColumnFilter",
  filterParams: pctSetFilterParams,

  valueGetter: function (params) {
    var row = (params && params.data) ? params.data : {};

    var total = Number(row.total_grs);
    if (!isFinite(total)) total = 0;

    var within = Number(row.within_120h);
    if (!isFinite(within)) within = 0;

    var over = total > 0 ? (total - within) : 0;
    var pct = total > 0 ? (over / total) * 100 : 0;

    if (!isFinite(pct)) pct = 0;

    return pctBucket(pct);
  },

  cellRenderer: function (params) {
    var row = (params && params.data) ? params.data : {};

    var total = Number(row.total_grs);
    if (!isFinite(total)) total = 0;

    var within = Number(row.within_120h);
    if (!isFinite(within)) within = 0;

    var over = total > 0 ? (total - within) : 0;
    var pct = total > 0 ? (over / total) * 100 : 0;

    if (!isFinite(pct)) pct = 0;

    // Tooltip text
    var tip = over + " of " + total;
    tip = String(tip).replace(/"/g, "&quot;");

    return (
      '<div class="miniBlock" title="' + tip + '">' +
        '<div class="bold">' + pct.toFixed(1) + '%</div>' +
        '<div class="miniBar">' +
          '<div class="miniBarFill redFill" style="width:' + Math.min(pct, 100) + '%"></div>' +
        "</div>" +
      "</div>"
    );
  }
}
,

    // Avg Transit Time
    {
      headerName: "Avg. Transit Time",
      field: "avg_transit_time",
      width: 150,
      filter: "agSetColumnFilter",
      filterParams: setFilterParams,
      cellRenderer: function (params) {
        var val = n(params && params.value);
        return (
          '<div class="tc">' +
            '<div class="bigNumber purpleText">' + val.toFixed(1) + "h</div>" +
            // '<div class="mutedSmall">average</div>' 
            // +
          "</div>"
        );
      },
    },

    // Total GRs
    {
      headerName: "Total GRs nos.",
      field: "total_grs",
      filter: "agSetColumnFilter",
      filterParams: setFilterParams,
      width: 110,
      cellRenderer: bigNumberCell("blueText", "total"),
    },

    // Delivered GRs
    {
      headerName: "Delivered GRs nos.",
      field: "delivered_grs",
      filter: "agSetColumnFilter",
      filterParams: setFilterParams,
      width: 125,
      cellRenderer: bigNumberCell("greenText", "deliveries"),
    },

    // GR within 90 Hours
    {
      headerName: "GR within 90 Hours (nos.)",
      field: "delivered_within_90h",
      filter: "agSetColumnFilter",
      filterParams: setFilterParams,
      width: 150,
      cellRenderer: bigNumberCell("blueText", "count"),
    },

    // In Transit
    {
      headerName: "In Transit GR(nos.)",
      field: "in_transit_count",
      filter: "agSetColumnFilter",
      filterParams: setFilterParams,
      width: 130,
      cellRenderer: bigNumberCell("orangeText", "in transit"),
    },
     {
      headerName: "Invalid Transit Time GRs",
      field: "invalid_grs",
      filter: "agSetColumnFilter",
      filterParams: setFilterParams,
      width: 150,
      cellRenderer: bigNumberCell("redText", "", "transit"),
    },

    // Truck Cost
    {
      headerName: "Truck Cost(₹)",
      field: "truck_cost",
      filter: "agSetColumnFilter",
      filterParams: setFilterParams,
      width: 110,
      cellRenderer: moneyCell("blueText"),
    },

    // Courier Cost
    {
      headerName: "Courier Cost(₹)",
      field: "courier_cost",
      filter: "agSetColumnFilter",
      filterParams: setFilterParams,
      width: 120,
      cellRenderer: moneyCell("blueText"),
    },

    // Savings
    {
      headerName: "Savings(₹)",
      field: "savings",
      filter: "agSetColumnFilter",
      filterParams: setFilterParams,
      width: 100,
      cellRenderer: savingsCell()
    },
   
  ];
}
async function submitDateFilters() {

    await fetchData()

    const isAllTab = activeSubTab === "all"
    const type = isAllTab ? "all" : "gurgaon"
    const timeRange = isAllTab ? timeRangeAll : timeRangeGurgaon
    const hub = isAllTab ? trendHub : gurgoanTrendHub
    const warehouse = isAllTab ? trendWarehouse : gurgaonWarehouse

    const tdata = await fetchTrendData(type, timeRange, hub, warehouse)
    if (isAllTab) setTrendApiAll(tdata)
    else setTrendApiGurgaon(tdata)



  }


  // -------------------------------
  // RENDER
  // -------------------------------
  return (
    <div className="ldWrap">
      {/* ALL WAREHOUSES TAB CONTENT */}
      {activeSubTab === "all" && (
        <div className="section">
          <DashboardHeaderBanner>
            <div className="sectionHeader">
              <div className="sectionTitleLeft blueBorder">
                <div className="sectionTitle">All Warehouses (24hr/48hr)</div>
              </div>
              <div className="mutedText">Last refreshed: {formatRefreshTime(lastRefreshTime)}</div>
            </div>
          </DashboardHeaderBanner>
          <div className="hmCardBody hmCardBodyCompact" style={{ paddingLeft: "0px" }}>
                          <div className="hmFilterGridStyle">
                            <div className="hmField">
                              <label className="hmLabel" htmlFor="from-date">
                                From Date
                              </label>
                              <input
                                id="from-date"
                                className="hmInput"
                                type="date"
                                value={fromDate}
                                onChange={function (e) {
                                  setFromDate(e.target.value)
                                }}
                              />
                            </div>
          
                            <div className="hmField">
                              <label className="hmLabel" htmlFor="to-date">
                                To Date
                              </label>
                              <input
                                id="to-date"
                                className="hmInput"
                                type="date"
                                value={toDate}
                                onChange={function (e) {
                                  setToDate(e.target.value)
                                }}
                              />
                            </div>
          
          
              <div className="hmField hmFieldBtn">
                <button
                  className="submit-btn"
                  type="button"
                  // onClick={submitDateFilters}
                  disabled={true}
                >
                  Submit
                </button>
              </div>
                          </div>
                        </div>
                          {loading &&
            <div className="centerScreen">
              <div className="loadingText">Loading dashboard...</div>
            </div>}

          {/* KPI Row */}
          {!loading && <>
          <div className="kpiGrid">
            <div className="card kpiCard">
              <div className="kpiContent">
                <IconBox bg="blueSoft" color="blueText">🏢</IconBox>
                <div className="kpiText">
                  <div className="kpiLabel">Total Hubs</div>
                  <div className="kpiValue">{countersData.totalHubs}</div>
                </div>
              </div>
            </div>

            <div className="card kpiCard">
              <div className="kpiContent">
                <IconBox bg="blueSoft" color="blueText">📦</IconBox>
                <div className="kpiText">
                  <div className="kpiLabel">Total GRs</div>
                  <div className="kpiValue">{countersData.totalGRs}</div>
                </div>
              </div>
            </div>

            <div className="card kpiCard">
              <div className="kpiContent">
                <IconBox bg="greenSoft" color="greenText">✅</IconBox>
                <div className="kpiText">
                  <div className="kpiLabel">Delivered GRs</div>
                  <div className="kpiValue">
                    {/* //sobcomment */}
                    {/* {hubSummary.reduce(function (sum, h) {
                      return sum + h.deliveredGRs;
                    }, 0)} */}
                    {countersData.deliveredGRs}
                  </div>
                </div>
              </div>
            </div>

            <div className="card kpiCard">
              <div className="kpiContent">
                <IconBox bg="orangeSoft" color="orangeText">🚚</IconBox>
                <div className="kpiText">
                  <div className="kpiLabel">In Transit GRs</div>
                  <div className="kpiValue">{countersData.intransitGRs}</div>
                </div>
              </div>
            </div>

            <div className="card kpiCard">
              <div className="kpiContent">
                <IconBox bg="redSoft" color="redText">🚫</IconBox>
                <div className="kpiText">
                  <div className="kpiLabel">Invalid GRs</div>
                  <div className="kpiValue">{countersData.invalidGRs}</div>
                </div>
              </div>
            </div>

            <div className="card kpiCard">
              <div className="kpiContent">
                <IconBox bg="yellowSoft" color="yellowText">📍</IconBox>
                <div className="kpiText">
                  <div className="kpiLabel">Hub Not Mapped GRs</div>
                  <div className="kpiValue">{countersData.unmappedHubGRs}</div>
                </div>
              </div>
            </div>

            <div className="card kpiCard">
              <div className="kpiContent">
                <IconBox bg="yellowSoft" color="yellowText">⏱️</IconBox>
                <div className="kpiText">
                  <div className="kpiLabel">{"<"}48 hours GRs</div>
                  <div className="kpiValue">
                    {/* {hubSummary.reduce(function (sum, h) {
                      return sum + h.grsWithin48Hours;
                    }, 0)} */}
                    {countersData.within48Hrs} ({countersData.within48HrsPct}%)
                  </div>
                </div>
              </div>
            </div>

            <div className="card kpiCard">
              <div className="kpiContent">
                <IconBox bg="redSoft" color="redText">⚠️</IconBox>
                <div className="kpiText">
                  <div className="kpiLabel">{">"}48 hours GRs</div>
                  <div className="kpiValue">
                    {/* {hubSummary.reduce(function (sum, h) {
                      return sum + (h.totalGRs - h.grsWithin48Hours);
                    }, 0)} */}
                    {countersData.gt48Hrs} ({countersData.gt48HrsPct}%)
                  </div>
                </div>
              </div>
            </div>

            <div className="card kpiCard">
              <div className="kpiContent">
                <IconBox bg="purpleSoft" color="purpleText">📈</IconBox>
                <div className="kpiText">
                  <div className="kpiLabel">Avg. Transit Time (hrs)</div>
                  <div className="kpiValue">
                    {/* {(
                      hubSummary.reduce(function (sum, h) {
                        return sum + h.avgTransitTime;
                      }, 0) / Math.max(hubSummary.length, 1)
                    ).toFixed(1)} */}
                    {countersData.avgTransitTime}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="card kpiCard">
              <div className="kpiContent">
                <IconBox bg="greenSoft" color="Text">₹</IconBox>
                <div className="kpiText">
                  <div className="kpiLabel">Savings (₹)</div>
                  <div className="kpiValue">
                  
                    {`${countersData.savings}M`}
                  </div>
                </div>
              </div>
            </div> */}
          </div>

          {/* Hub Performance Overview */}
          {showHubOverview && (
            <div className="card">
              <div className="cardHeader">
                <div className="cardHeaderRow">
                  <div className="cardTitle blueText">Hub Performance Overview</div>
                  <PerformanceLegend config={perfConfig} />
                </div>
              </div>

              <div className="cardBody">
         <div className="tableWrap">
  <div className="ag-theme-balham ddAgGrid ddAgGridBlue" style={{ width: "100%", height: 420 }}>
    <AgGridReact
      rowData={hubSummary}
      columnDefs={getAllHubColumnDefs(perfConfig)}
      defaultColDef={{
        sortable: true,
        filter: "agSetColumnFilter",     // ✅ default = checkbox filter for ALL columns
        floatingFilter: false,           // screenshot style (filter icon in header menu)
        resizable: true,
        minWidth: 120,
        menuTabs: ["filterMenuTab", "generalMenuTab", "columnsMenuTab"],
        filterParams: {
          buttons: ["reset", "apply"],
          closeOnApply: true,
          suppressMiniFilter: false,
          refreshValuesOnOpen: true,     // ✅ values list = only from grid rows
        },
      }}
      animateRows={true}
      headerHeight={45}
      rowHeight={70}
      suppressCellFocus={true}
      // ✅ Pagination
      pagination={true}
      paginationPageSize={20}
      paginationPageSizeSelector={[20, 50, 100, 200]}
    />
  </div>
</div>


              </div>
            </div>
          )}

          {/* PERFORMANCE COMPARISON  */}
          <div className="card">
  <div className="cardHeader">
    <div className="cardHeaderRow">
      <div className="cardTitle">Performance Comparison</div>

      <div className="btnGroup">
        <ButtonSimple
          variant={chartView === "gr" ? "primary" : "outline"}
          onClick={function () {
            setChartView("gr");
          }}
        >
          GR
        </ButtonSimple>

        <ButtonSimple
          variant={chartView === "transit" ? "primary" : "outline"}
          onClick={function () {
            setChartView("transit");
          }}
        >
          %
        </ButtonSimple>
      </div>
    </div>

    {/* Screenshot legend style (unchanged) */}
    <div className="legendRow below">
      <span className="legendItem"><span className="legendBox greenFill" /> Delivered GR</span>
      <span className="legendItem"><span className="legendBox blueFill" /> Within 24 Hours</span>
      <span className="legendItem"><span className="legendBox yellowFill" /> 24 to 36 Hours</span>
      <span className="legendItem"><span className="legendBox orangeFill" /> 36 to 48 Hours</span>
      <span className="legendItem"><span className="legendBox redFill" /> &gt; 48 Hours</span>
    </div>
  </div>

  <div className="cardBody">
    <div className="perfStack">
      {(perfComparison || [])
        // If you want to exclude GUJ like earlier, keep this filter (optional)
        // .filter((row) => String(row.warehouse).indexOf("GUJ") === -1)

        // Sort by best performance (lowest above_48h % = best)
        .slice()
        .sort(function (a, b) {
          var aTotal = a.delivered_grs || 1;
          var bTotal = b.delivered_grs || 1;

          var aPerf = ((aTotal - (a.above_48h || 0)) / aTotal) * 100; // within 48%
          var bPerf = ((bTotal - (b.above_48h || 0)) / bTotal) * 100;

          return bPerf - aPerf;
        })
        .slice(0, 5)
        .map(function (hub, index) {
          // ✅ Direct buckets from API
          var total = hub.delivered_grs || 1;

          var within24 = hub.delivered_within_24h || 0;
          var band24to36 = hub.delivered_in_between_24h_and_36h || 0;
          var band36to48 = hub.delivered_in_between_36h_and_48h || 0;
          var over48 = hub.above_48h || 0;

          // ✅ top green bar = delivered_grs (same style as before)
          var deliveredTopLabel = hub.delivered_grs || 0;

          // percentages for labels (GR view uses value + %)
          var pctBlue = (within24 / total) * 100;
          var pctYellow = (band24to36 / total) * 100;
          var pctOrange = (band36to48 / total) * 100;
          var pctRed = (over48 / total) * 100;

          // ✅ width logic (same UI)
          var wBlue = chartView === "gr" ? pctBlue : pctBlue;
          var wYellow = chartView === "gr" ? pctYellow : pctYellow;
          var wOrange = chartView === "gr" ? pctOrange : pctOrange;
          var wRed = chartView === "gr" ? pctRed : pctRed;

          // ✅ label text inside segments (same style behaviour)
          function segLabel(value, pct) {
            if (chartView === "gr") {
              if (pct < 6) return "";
              return String(value) + "(" + pct.toFixed(0) + "%)";
            } else {
              if (pct < 6) return "";
              return pct.toFixed(0) + "%";
            }
          }

          return (
            <div className="perfBlock" key={`${hub.warehouse}-${index}`}>
              <div className="perfHubTitle">{hub.warehouse}</div>

              {/* ROW = TOP GREEN BAR + BOTTOM STACKED BAR (NO GAP BETWEEN THEM) */}
              <div className="perfRow">
                <div className="perfTopBar">
                  <div className="perfTopFill greenFill">
                    <span className="barText">{deliveredTopLabel}</span>
                  </div>
                </div>

                <div className="perfBottomBar">
                  <div className="seg blueFill" style={{ width: wBlue + "%" }}>
                    <span className="barText">{segLabel(within24, pctBlue)}</span>
                  </div>

                  <div className="seg yellowFill" style={{ width: wYellow + "%" }}>
                    <span className="barText">{segLabel(band24to36, pctYellow)}</span>
                  </div>

                  <div className="seg orangeFill" style={{ width: wOrange + "%" }}>
                    <span className="barText">{segLabel(band36to48, pctOrange)}</span>
                  </div>

                  <div className="seg redFill" style={{ width: wRed + "%" }}>
                    <span className="barText">{segLabel(over48, pctRed)}</span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  </div>
</div>


          {/* Transit Time Trend */}
         <div className="card">
        <div className="cardHeader">
          <div className="cardHeaderRow">
            <div className="cardTitle">Transit Time Trend</div>

            <div className="filterRow">

              {/* Warehouse dropdown (kept as-is in UI) */}
              <SelectSimple
                value={trendWarehouse}
                onChange={function (e) {
                  setTrendWarehouse(e.target.value);
                }}
              >
                <option value="all">All Warehouses</option>
                {Array.from(
                      new Set(
                        hubSummary
                          .map(h => h.warehouse)
                          .filter(h => h && String(h).trim() !== "")
                      )
                    ).map(hub => (
                      <option key={hub} value={hub}>
                        {hub}
                      </option>
                    ))}
              </SelectSimple>

              {/* Hub dropdown */}
              <SelectSimple
                value={trendHub}
                onChange={function (e) {
                      setTrendHub(e.target.value);
                    }}
                  >
                    <option value="all">All Hubs</option>
                    {Array.from(
                      new Set(
                        hubSummary
                          .map(h => h.hub_location)
                          .filter(h => h && String(h).trim() !== "")
                      )
                    ).map(hub => (
                      <option key={hub} value={hub}>
                        {hub}
                      </option>
                    ))}
                  </SelectSimple>

                     {/* Weekly/Monthly/Yearly */}
              <SelectSimple
                value={timeRangeAll}
                onChange={function (e) {
                  setTimeRangeAll(e.target.value);
                }}
              >
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
                <option value="yearly">Yearly</option>
              </SelectSimple>
            </div>
          </div>
        </div>

        <div className="cardBody">
         <div className="chartBox">
  {trendLoading ? (
    <div className="trendLoaderWrap">
      <div className="trendLoader">Loading trend...</div>
    </div>
  ) : (
    <TransitTimeTrendChart
      data={trendData}
      timePeriod={timeRangeAll}
      warehouseType="all" 
    />
  )}
</div>

          {/* Mini cards exactly like screenshot structure */}
          <MiniCardsFromTrend data={trendData} labelShown="Total Hubs" />
        </div>
      </div>        </>}

        </div>
      )}

      {/* GURGAON TAB CONTENT */}
      {activeSubTab === "gurgaon" && (
        <div className="section">
          <DashboardHeaderBanner>
            <div className="sectionHeader">
              <div className="sectionTitleLeft orangeBorder">
                <div className="sectionTitle">Gurgaon Warehouse (90hr/120hr)</div>
              </div>
              <div className="mutedText">Last refreshed: {formatRefreshTime(lastRefreshTime)}</div>
            </div>
          </DashboardHeaderBanner>
          <div className="hmCardBody hmCardBodyCompact" style={{ paddingLeft: "0px" }}>
                          <div className="hmFilterGridStyle">
                            <div className="hmField">
                              <label className="hmLabel" htmlFor="from-date">
                                From Date
                              </label>
                              <input
                                id="from-date"
                                className="hmInput"
                                type="date"
                                value={fromDate}
                                onChange={function (e) {
                                  setFromDate(e.target.value)
                                }}
                              />
                            </div>
          
                            <div className="hmField">
                              <label className="hmLabel" htmlFor="to-date">
                                To Date
                              </label>
                              <input
                                id="to-date"
                                className="hmInput"
                                type="date"
                                value={toDate}
                                onChange={function (e) {
                                  setToDate(e.target.value)
                                }}
                              />
                            </div>
          

              <div className="hmField hmFieldBtn">
                <button
                  className="submit-btn"
                  type="button"
                  // onClick={submitDateFilters}
                  disabled={true}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
          {loading &&
            <div className="centerScreen">
              <div className="loadingText"> Loading dashboard...</div>
            </div>}

          {!loading && <>
            <div className="kpiGridGurgaon">
              <div className="card kpiCard">
                <div className="kpiContent">
                  <IconBox bg="orangeSoft" color="orangeText">🏢</IconBox>
                  <div className="kpiText">
                    <div className="kpiLabel">Gurgaon Hubs</div>
                    <div className="kpiValue">{gurgaonCountersData.gurgaonHubs}</div>
                  </div>
                </div>
              </div>

              <div className="card kpiCard">
                <div className="kpiContent">
                  <IconBox bg="blueSoft" color="blueText">📦</IconBox>
                  <div className="kpiText">
                    <div className="kpiLabel">Total GRs</div>
                    <div className="kpiValue">{gurgaonCountersData.totalGRs}</div>
                  </div>
                </div>
              </div>

              <div className="card kpiCard">
                <div className="kpiContent">
                  <IconBox bg="greenSoft" color="greenText">✅</IconBox>
                  <div className="kpiText">
                    <div className="kpiLabel">Delivered GRs</div>
                    <div className="kpiValue">{gurgaonCountersData.deliveredGRs}
                    </div>
                  </div>
                </div>
              </div>

              <div className="card kpiCard">
                <div className="kpiContent">
                  <IconBox bg="orangeSoft" color="orangeText">🚚</IconBox>
                  <div className="kpiText">
                    <div className="kpiLabel">In Transit GRs</div>
                    <div className="kpiValue">{gurgaonCountersData.intransitGRs}</div>
                  </div>
                </div>
              </div>

              <div className="card kpiCard">
                <div className="kpiContent">
                  <IconBox bg="redSoft" color="redText">🚫</IconBox>
                  <div className="kpiText">
                    <div className="kpiLabel">Invalid GRs</div>
                    <div className="kpiValue">{gurgaonCountersData.invalidGRs}</div>
                  </div>
                </div>
              </div>

              <div className="card kpiCard">
                <div className="kpiContent">
                  <IconBox bg="yellowSoft" color="yellowText">📍</IconBox>
                  <div className="kpiText">
                    <div className="kpiLabel">Hub Not Mapped GRs</div>
                    <div className="kpiValue">{gurgaonCountersData.unmappedHubGRs}</div>
                  </div>
                </div>
              </div>

              <div className="card kpiCard">
                <div className="kpiContent">
                  <IconBox bg="yellowSoft" color="yellowText">⏱️</IconBox>
                  <div className="kpiText">
                    <div className="kpiLabel">{"<"}120 hours GRs</div>
                    <div className="kpiValue">
                      {gurgaonCountersData.within120Hrs} ({gurgaonCountersData.within120HrsPct}%)
                    </div>
                  </div>
                </div>
              </div>

              <div className="card kpiCard">
                <div className="kpiContent">
                  <IconBox bg="redSoft" color="redText">⚠️</IconBox>
                  <div className="kpiText">
                    <div className="kpiLabel">{">"}120 hours GRs</div>
                    <div className="kpiValue">
                      {gurgaonCountersData.gt120Hrs} ({gurgaonCountersData.gt120HrsPct}%)
                    </div>
                  </div>
                </div>
              </div>

              <div className="card kpiCard">
                <div className="kpiContent">
                  <IconBox bg="purpleSoft" color="purpleText">📈</IconBox>
                  <div className="kpiText">
                    <div className="kpiLabel">Avg. Transit Time (hrs)</div>
                    <div className="kpiValue">
                      {gurgaonCountersData.avgTransitTime}
                    </div>
                  </div>
                </div>
              </div>
              <div className="card kpiCard">
                <div className="kpiContent">
                  <IconBox bg="greenSoft" color="Text">₹</IconBox>
                  <div className="kpiText">
                    <div className="kpiLabel">Savings (₹)</div>
                    <div className="kpiValue">
                      {/* {(
                      hubSummary.reduce(function (sum, h) {
                        return sum + h.avgTransitTime;
                      }, 0) / Math.max(hubSummary.length, 1)
                    ).toFixed(1)} */}
                      {`${gurgaonCountersData.savings}M`}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {showGurgaonHubOverview && (
              <div className="card">
                <div className="cardHeader">
                  <div className="cardHeaderRow">
                    <div className="cardTitle orangeText">Hub Performance Overview</div>
                    <PerformanceLegend config={perfConfig} />
                  </div>
                </div>

                <div className="cardBody">
                  <div className="tableWrap">
                    <div
                      className="ag-theme-balham ddAgGrid ddAgGridOrange"
                      style={{ width: "100%", height: 420 }}
                    >
                      <AgGridReact
                        rowData={gurgaonHubSummary}
                        columnDefs={getGurgaonHubColumnDefs(perfConfig)}
                        defaultColDef={{
                          sortable: true,
                          filter: "agSetColumnFilter",
                          floatingFilter: false,
                          resizable: true,
                          minWidth: 90,
                          menuTabs: ["filterMenuTab", "generalMenuTab", "columnsMenuTab"],
                          filterParams: {
                            buttons: ["reset", "apply"],
                            closeOnApply: true,
                            suppressMiniFilter: false,
                            refreshValuesOnOpen: true,
                          },
                        }}
                        animateRows={true}
                        headerHeight={45}
                        rowHeight={70}
                        suppressCellFocus={true}
                        pagination={true}
                        paginationPageSize={20}
                        paginationPageSizeSelector={[20, 50, 100, 200]}
                      />
                    </div>
                  </div>

                </div>
              </div>
            )}

          {/* Gurgaon Performance Comparison (same visual model) */}
          <div className="card">
            <div className="cardHeader">
              <div className="cardHeaderRow">
                <div className="cardTitle">Performance Comparison</div>
                <div className="btnGroup">
                  <ButtonSimple
                    variant={gurgaonChartView === "gr" ? "primary" : "outline"}
                    onClick={function () {
                      setGurgaonChartView("gr");
                    }}
                  >
                    GR
                  </ButtonSimple>
                  <ButtonSimple
                    variant={gurgaonChartView === "transit" ? "primary" : "outline"}
                    onClick={function () {
                      setGurgaonChartView("transit");
                    }}
                  >
                    %
                  </ButtonSimple>
                </div>
              </div>

              <div className="legendRow below">
                <span className="legendItem"><span className="legendBox greenFill" /> Delivered</span>
                <span className="legendItem"><span className="legendBox blueFill" /> Within 48 Hours</span>
                <span className="legendItem"><span className="legendBox yellowFill" /> 48 to 90 Hours</span>
                <span className="legendItem"><span className="legendBox orangeFill" /> 90 to 120 Hours</span>
                <span className="legendItem"><span className="legendBox redFill" /> &gt; 120 Hours</span>
              </div>
            </div>

            <div className="cardBody">
              <div className="perfStack">
      {(gurgaonPerfComparison || [])
        // If you want to exclude GUJ like earlier, keep this filter (optional)
        // .filter((row) => String(row.warehouse).indexOf("GUJ") === -1)

        // Sort by best performance (lowest above_48h % = best)
        .slice()
        .sort(function (a, b) {
          var aTotal = a.delivered_grs || 1;
          var bTotal = b.delivered_grs || 1;

          var aPerf = ((aTotal - (a.above_120h || 0)) / aTotal) * 100; // within 48%
          var bPerf = ((bTotal - (b.above_120h || 0)) / bTotal) * 100;

          return bPerf - aPerf;
        })
        .slice(0, 5)
        .map(function (hub, index) {
          // ✅ Direct buckets from API
          var total = hub.delivered_grs || 1;

          var within48 = hub.delivered_within_48h || 0;
          var band48to90 = hub.delivered_in_between_48h_and_90h || 0;
          var band90to120 = hub.delivered_in_between_90h_and_120h || 0;
          var over120 = hub.above_120h || 0;

          // ✅ top green bar = delivered_grs (same style as before)
          var deliveredTopLabel = hub.delivered_grs || 0;

          // percentages for labels (GR view uses value + %)
          var pctBlue = (within48 / total) * 100;
          var pctYellow = (band48to90 / total) * 100;
          var pctOrange = (band90to120 / total) * 100;
          var pctRed = (over120 / total) * 100;

          // ✅ width logic (same UI)
          var wBlue = gurgaonChartView === "gr" ? pctBlue : pctBlue;
          var wYellow = gurgaonChartView === "gr" ? pctYellow : pctYellow;
          var wOrange = gurgaonChartView === "gr" ? pctOrange : pctOrange;
          var wRed = gurgaonChartView === "gr" ? pctRed : pctRed;

          // ✅ label text inside segments (same style behaviour)
          function segLabel(value, pct) {
            if (chartView === "gr") {
              if (pct < 6) return "";
              return String(value) + "(" + pct.toFixed(0) + "%)";
            } else {
              if (pct < 6) return "";
              return pct.toFixed(0) + "%";
            }
          }

          return (
            <div className="perfBlock" key={`${hub.warehouse}-${index}`}>
              <div className="perfHubTitle">{hub.warehouse}</div>

              {/* ROW = TOP GREEN BAR + BOTTOM STACKED BAR (NO GAP BETWEEN THEM) */}
              <div className="perfRow">
                <div className="perfTopBar">
                  <div className="perfTopFill greenFill">
                    <span className="barText">{deliveredTopLabel}</span>
                  </div>
                </div>

                <div className="perfBottomBar">
                  <div className="seg blueFill" style={{ width: wBlue + "%" }}>
                    <span className="barText">{segLabel(within48, pctBlue)}</span>
                  </div>

                  <div className="seg yellowFill" style={{ width: wYellow + "%" }}>
                    <span className="barText">{segLabel(band48to90, pctYellow)}</span>
                  </div>

                  <div className="seg orangeFill" style={{ width: wOrange + "%" }}>
                    <span className="barText">{segLabel(band90to120, pctOrange)}</span>
                  </div>

                  <div className="seg redFill" style={{ width: wRed + "%" }}>
                    <span className="barText">{segLabel(over120, pctRed)}</span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
    </div>
            </div>
          </div>

          {/* Transit Time Trend Gurgaon */}
           <div className="card">
        <div className="cardHeader">
          <div className="cardHeaderRow">
            <div className="cardTitle">Transit Time Trend</div>

            <div className="filterRow">
              {/* Warehouse dropdown (GUJ only) */}
              <SelectSimple
                value={gurgaonWarehouse}
                onChange={function (e) {
                  setGurgaonWarehouse(e.target.value);
                }}
              >
                <option value="all">All Warehouses</option>
                 {Array.from(
                      new Set(
                        gurgaonHubSummary
                          .map(h => h.warehouse)
                          .filter(h => h && String(h).trim() !== "")
                      )
                    ).map(hub => (
                      <option key={hub} value={hub}>
                        {hub}
                      </option>
                    ))}
              </SelectSimple>

                {/* Hub dropdown */}
              <SelectSimple
                value={gurgoanTrendHub}
                onChange={function (e) {
                  setGurgoanTrendHub(e.target.value);
                }}
              >
                <option value="all">All Hubs</option>
                {gurgaonHubSummary.map(function (hub, index) {
                  return (
                    <option key={`${hub.hub_location}-${index}`} value={hub.hub_location}>
                      {hub.hub_location}
                    </option>
                  );
                })}
              </SelectSimple>

               {/* Weekly/Monthly/Yearly */}
              <SelectSimple
                value={timeRangeGurgaon}
                onChange={function (e) {
                  setTimeRangeGurgaon(e.target.value);
                }}
              >
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
                <option value="yearly">Yearly</option>
              </SelectSimple>
            </div>
          </div>
        </div>

        <div className="cardBody">

                <div className="chartBox">
                  {trendLoading ? (
                    <div className="trendLoaderWrap">
                      <div className="trendLoader">Loading trend...</div>
                    </div>
                  ) : (
                    <TransitTimeTrendChart data={gurgoanTrendData} warehouseType="gurgaon" timePeriod={timeRangeGurgaon} />

                  )}
                </div>

          <MiniCardsFromTrend data={gurgoanTrendData} labelShown="Total Hubs" />
        </div>
      </div></>}
        </div>
      )}

      
    </div>
  );
}

function computeSummaryFromTrend(trendArr, topN, activeSubTab) {
  var agg = {}; // hub -> {sumWeighted, sumCount, totalCount}
  for (var i = 0; i < trendArr.length; i++) {
    var r = trendArr[i];
      var hub = "";
    if (activeSubTab === "all") {
      hub = r && r.consigner_code ? r.consigner_code : "";
    } else {
      hub = r && r.hub_location ? r.hub_location : "";
    }
    var avg = typeof r.avg_duration === "number" ? r.avg_duration : parseFloat(r.avg_duration || 0);
    var cnt = typeof r.count === "number" ? r.count : parseFloat(r.count || 0);

    if (!agg[hub]) agg[hub] = { sumWeighted: 0, sumCount: 0, totalCount: 0 };
    agg[hub].sumWeighted += avg * (cnt > 0 ? cnt : 1);
    agg[hub].sumCount += cnt > 0 ? cnt : 1;
    agg[hub].totalCount += cnt > 0 ? cnt : 1;
  }

  var hubs = Object.keys(agg);
  if (hubs.length === 0) {
    return { shownCount: 0, bestHub: "", bestAvg: 0, poorHub: "", poorAvg: 0 };
  }

  // pick topN hubs by totalCount
  hubs.sort(function (a, b) {
    return agg[b].totalCount - agg[a].totalCount;
  });
  var shown = hubs.slice(0, topN);

  var bestHub = "";
  var bestAvg = Infinity;
  var poorHub = "";
  var poorAvg = -Infinity;

  for (var j = 0; j < shown.length; j++) {
    var h = shown[j];
    var denom = agg[h].sumCount || 1;
    var overallAvg = agg[h].sumWeighted / denom;

    if (overallAvg < bestAvg) {
      bestAvg = overallAvg;
      bestHub = h;
    }
    if (overallAvg > poorAvg) {
      poorAvg = overallAvg;
      poorHub = h;
    }
  }

  return {
    shownCount: shown.length,
    bestHub: bestHub,
    bestAvg: bestAvg === Infinity ? 0 : bestAvg,
    poorHub: poorHub,
    poorAvg: poorAvg === -Infinity ? 0 : poorAvg,
  };
}
 function moneyCell(colorClass, label) {
  return function (params) {
    var value = Number(params && params.value) || 0;

    // Convert to Million
    var millionValue = value / 1000000;

    // Format to 2 decimals and add M
    var formattedValue = millionValue.toFixed(2) + "M";

    return (
      '<div class="tc">' +
        '<div class="bigNumber ' + colorClass + '">' + formattedValue + "</div>" +
        // '<div class="mutedSmall">' + (label || "(₹) cost")
        //  +
         "</div>" +
      "</div>"
    );
  };
}

 function savingsCell() {
  return function (params) {
    var value = Number(params && params.value) || 0;

    // Convert rupees to million
    var millionValue = value / 1000000;

    var formattedValue = millionValue.toFixed(2) + "M";

    return (
      '<div class="tc">' +
        '<div class="bigNumber greenText">' + formattedValue + "</div>" +
        // '<div class="mutedSmall">(₹ saving)</div>' +
      "</div>"
    );
  };
}
function convertToMillion(value) {
  const numberValue = Number(value) || 0;   // convert to number safely
  const millionValue = numberValue / 1000000; 
  return Number(millionValue.toFixed(2));   // keep as number (better for grid sorting)
}
function formatInputDate(value) {
  if (!value) return "";
  var d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return "";

  var dd = String(d.getDate()).padStart(2, "0");
  var mm = String(d.getMonth() + 1).padStart(2, "0");
  var yyyy = d.getFullYear();

  return yyyy + "-" + mm + "-" + dd;
}